//CrimeResults.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as ResultsFS from "../Util/ResultsFS";
import * as CrimeResultsHeading from "./CrimeResultsHeading";
import * as CrimeSearch from "./CrimeSearch";
import * as Settings_Crime from "./Settings_Crime";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import { Paper } from "@mui/material";

import React from "react";

const toolName: string = "Crime Results";
let scrolling: boolean = false;
let append: boolean;  //True if scrolling to append more records.
const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";
let ss: Settings_Crime.iSS; //Settings.

//Get number of selected properties.
export function getNumSelected(): number {
   let numSel: number = 0;

   if (CrimeSearch.layer.totRec > 0) {
      for (const feature of CrimeSearch.layer.fs.features) {
         const gra = feature as any;
         if (gra.rowSelected) {
            numSel++;
         }
      }
   }
   return numSel;
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of CrimeResults Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = Settings_Crime.ss; //Get settings.
   }

   let resultsVisible: boolean = true;
   if (DrawerMenu.curToolName !== toolName) {
      resultsVisible = false; //Hide the results if fading out.
   }

   let lay: Search.iLayer = null;

   if (resultsVisible) {
      lay = CrimeSearch.layer;
      if (!lay || !lay.fs || !lay.fs.features) {
         resultsVisible = false; 
      }
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did update.
   React.useEffect(() => {
      // Spinner.hide(); //Hide the spinner for all search modes.
      Util.logMsg("CrimeResults did update");
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Show more left panel records when scrolling to bottom.
   function handleScroll(event: React.UIEvent<HTMLDivElement>) {
      if (!resultsVisible) {
         return; //Quit if fading out.
      }
      const target = event.currentTarget;
      const percent: number = target.scrollTop / (target.scrollHeight - target.clientHeight) * 100;
      const prevNumRec: number = lay.numRec;

      if (percent > 98) {
         lay.numRec = Math.min((lay.endRec - lay.begRec) + 1, lay.numRec + Settings.maxSearchRecPerPage);
         if (lay.numRec > prevNumRec) {

            if (Spinner.busy) {
               return;
            }
            // Spinner.show();
            scrolling = true;
            setTimeout(function () { refresh(); }, 100); //Wait for spinner to render.
         }
      }
   }

   //Tool title.
   let title: string = toolName;
   if (resultsVisible) {
      title += " (" + lay.totRec + " " + lay.name + ")";
   }

   //Set scrolling and paging status.
   append = false;
   if (scrolling) {
      append = true;
      scrolling = false;
   }

   //Set results to crime points layer name.
   let results: ResultsFS.iResult[];

   if (resultsVisible) {
      results = [{
         toolName: toolName, layerName: lay.name, fs: lay.fs, IDs: [], begRec: lay.begRec, numRec: lay.numRec, layerNameVisible: false, append: append,
      }];
   }
   //Util.errMsg("results", results);

   //Styling.
   const styles: Default.iStyles = {
      resultsDiv: { overflow: "auto", marginTop: 7 },
   };

   return (
      <Paper>
         <WidgetHeading.Render title={title} onClose={close} />

         <div style={Default.styles.appToolDiv}>
            {resultsVisible && <CrimeResultsHeading.Render />}

            <div id={scrollDivID} style={styles.resultsDiv} onScroll={handleScroll}>
               {resultsVisible && <ResultsFS.Render results={results} />}
            </div>
         </div>

      </Paper>
   ); //end return.

} //end function.
